export default function objectEach(object, iterator) {
  for (var key in object) {
    iterator(object[key], key);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-plugin-named-media-query/node_modules/fela-utils/es/objectEach.js
// module id = 982
// module chunks = 1